import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { apiErrorText } from "@/lib/api";
import { Airplane } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      toast.error(apiErrorText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-background">
      <div className="hidden md:flex flex-col justify-between p-12 border-r border-border w-1/2 grid-lines relative overflow-hidden">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/logo.png" alt="SkyInspect" className="w-16 h-16 object-contain rounded-md bg-white/95 p-1.5" />
            <div>
              <div className="font-black text-2xl leading-none" style={{ fontFamily: "Manrope" }}>SkyInspect</div>
              <div className="label-tech text-muted-foreground mt-1">Soluções em Drone · ERP</div>
            </div>
          </div>
        </div>
        <div className="relative z-10">
          <div className="label-tech text-accent mb-4">// operations center</div>
          <h2 className="text-4xl font-black tracking-tighter mb-4" style={{ fontFamily: "Manrope" }}>
            Precisão aérea.<br/>Gestão terrestre.
          </h2>
          <p className="text-muted-foreground max-w-md">
            Cadastre clientes, agende inspeções, gere propostas e contratos em PDF, e sincronize seu calendário com Google — tudo em um único painel.
          </p>
        </div>
        <div className="grid grid-cols-3 gap-4 text-xs">
          <div className="border-l-2 border-primary pl-3">
            <div className="label-tech text-muted-foreground">RBAC-E 94</div>
            <div className="font-bold mt-1">Compliance ANAC</div>
          </div>
          <div className="border-l-2 border-accent pl-3">
            <div className="label-tech text-muted-foreground">Google Cal</div>
            <div className="font-bold mt-1">Sincronização</div>
          </div>
          <div className="border-l-2 border-primary pl-3">
            <div className="label-tech text-muted-foreground">PDF</div>
            <div className="font-bold mt-1">Docs prontos</div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <div className="label-tech text-primary mb-3">// acesso restrito</div>
            <h1 className="text-4xl font-black tracking-tighter" style={{ fontFamily: "Manrope" }}>Entrar</h1>
            <p className="text-muted-foreground mt-2">Acesse o painel de operações</p>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="label-tech">E-mail</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email" required autoComplete="email" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="label-tech">Senha</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password" required autoComplete="current-password" />
            </div>
          </div>

          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-11 font-bold">
            {loading ? "Entrando..." : "ENTRAR NO PAINEL"}
          </Button>

          <div className="text-center text-sm text-muted-foreground">
            Não tem conta?{" "}
            <Link to="/register" className="text-accent font-semibold hover:underline" data-testid="link-register">
              Criar conta
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
